import background from '../../../assests/internship/intern-background-home.png'
import internship2 from '../../../assests/internship/internship-home2.png'
import internship5 from '../../../assests/internship/internship-home4.png'
import image1 from '../../../assests/internship/Live coaching.png'
import image2 from '../../../assests/internship/Beginner Level.png'
import image3 from '../../../assests/internship/Official Certification.png'
import image4 from '../../../assests/internship/One-on-one sessions.png'
import image5 from '../../../assests/internship/placement assistance.png'
import image6 from '../../../assests/internship/Top Industry Trainers.png'
import person2 from '../../../assests/internship/person2.png'
import '../internship.css'

import { FacebookFilled, InstagramOutlined, LinkedinFilled, WhatsAppOutlined, YoutubeOutlined } from '@ant-design/icons'

import about from "../../../assests/about_image.png";
import Header from '../../componets/header/header'
import Footer from '../../componets/footer/footer'
function InternshipGraphics() {
    const handleDownload = () => {
        // const pdfUrl = new URL("../../../assests/internship/Graphic_Design_Brochure.pdf", import.meta.url).href;
        const link = document.createElement("a");
        // link.href = pdfUrl;
        link.download = "Graphic_Design_Brochure.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const syllabusItems = [
        ['Design Fundamentals', 'Color Theory & Typography', 'Adobe Photoshop Basics', 'Image Editing & Retouching', 'Logo Design Principles', 'Brand Identity Creation', 'Print Design Layouts', 'Portfolio Development', 'Client Communication'],
        ['Advanced Photoshop', 'Adobe Illustrator Mastery', 'Vector Graphics Creation', 'Icon & Symbol Design', 'Packaging Design', 'Social Media Graphics', 'Web Design Elements', 'Creative Problem Solving'],
        ['Adobe InDesign', 'Layout & Composition', 'Canva Pro Techniques', 'Digital Marketing Visuals', 'Motion Graphics Basics', 'Brand Guidelines', 'Freelancing Skills', 'Industry Best Practices'],
    ];
    return (
        <div>
            <Header />
            <div >
                <section className="hero">
                    <div className="text_values">

                        <h1>Creative Graphic Design Education, Powered by Papa Digital Academy</h1>


                        <div className="social-icons">
                            <a href='https://www.facebook.com/papadigitalsolution' target="_blank" rel="noopener noreferrer">
                                <FacebookFilled style={{ color: "white" }} />
                            </a>
                            <a href='https://www.instagram.com/papaekmpapa/' target="_blank" rel="noopener noreferrer">
                                <InstagramOutlined className="fab fa-instagram" style={{ color: "white" }} />
                            </a>
                            <a href='https://www.youtube.com/@Papadigitalsolution' target="_blank" rel="noopener noreferrer">
                                <YoutubeOutlined className="fab fa-youtube" style={{ color: "white" }} />
                            </a>
                            <a href='https://www.linkedin.com/company/papa-digital-solution/posts/?feedView=all' target="_blank" rel="noopener noreferrer">
                                <LinkedinFilled className="fab fa-linkedin-in" style={{ color: "white" }} />
                            </a>
                            <a href='https://wa.me/919562121117' target="_blank" rel="noopener noreferrer">
                                <WhatsAppOutlined className="fab fa-whatsapp" style={{ color: "white" }} />
                            </a>
                        </div>
                    </div>

                    <img src={background} alt="Group of Students" style={{
                        position: 'absolute',
                        bottom: 0,
                        maxWidth: '100%',
                        height: 'auto',
                        zIndex: 2,
                    }} />


                </section>
                <section className="overlay-section">
                    <img src={internship2} alt="Graphic Design" className="background-image" />
                    <div className="overlay-content">
                        <h2>Best Online Graphic Design Courses in India</h2>
                        <p>At Papa Digital Academy, we help creative minds transform their artistic vision into professional design skills through industry-focused
                            graphic design training. Our live online courses are
                            designed to give you hands-on experience with real-world
                            projects used by top design agencies and creative studios.

                            Many of our students have seen fast-track growth—whether landing their first design job,
                            switching careers, or starting their own design business. Our curriculum is built to match the needs
                            of the modern creative industry, helping
                            learners gain the skills employers and clients are actively looking for.
                        </p>
                        <p>
                            What makes Papa Digital Academy stand out is the creative value it brings to your
                            career. As your design skills improve, so do your job opportunities and earning potential.
                            Our learners often see significant salary growth after completing
                            the program, making their investment both smart and rewarding.

                            Join Papa Digital Academy and take the next big step toward a successful, future-proof career in graphic design and visual communication.
                        </p>
                    </div>
                </section>
                <section className="course-audience-section">
                    <h2>WHO SHOULD ATTEND THE COURSE</h2>
                    <div className="audience-cards-container">
                        <div className="audience-card">
                            <span className="card-number">1</span>
                            <h3>For Students & Graduates</h3>
                            <h4>Launch Your Creative Career!</h4>
                            <p>
                                Are you ready to be the next in-demand Graphic Design Professional? Dive into our comprehensive
                                courses designed to catapult you into the creative industry with the most sought-after design skills.
                                Let's turn your artistic potential into professional success!
                            </p>
                        </div>

                        <div className="audience-card">
                            <span className="card-number">2</span>
                            <h3>For Homemakers</h3>
                            <h4>Unleash Your Creative Potential!</h4>
                            <p>
                                Thinking of turning your creative passion into a career? Our flexible graphic design programs are perfect for
                                gaining professional design skills at your own pace. Empower yourself to step into the creative world with confidence
                                and artistic flair!
                            </p>
                        </div>

                        <div className="audience-card">
                            <span className="card-number">3</span>
                            <h3>For Working Professionals</h3>
                            <h4>Enhance Your Creative Skills!</h4>
                            <p>
                                Feel like adding a creative edge to your current role? It's time to up-skill with our
                                cutting-edge graphic design training. Enhance your resume with visual communication skills and watch new creative opportunities
                                open as you transform your professional capabilities!
                            </p>
                        </div>

                        <div className="audience-card">
                            <span className="card-number">4</span>
                            <h3>For Entrepreneurs</h3>
                            <h4>Brand Your Business Visually!</h4>
                            <p>
                                Ready to create stunning visuals for your business? Learn how to design compelling graphics, logos, and marketing materials
                                that attract customers and significantly boost your brand presence through professional design strategies. Join us and watch your
                                business stand out visually!
                            </p>
                        </div>
                        <div className="audience-card">
                            <span className="card-number">5</span>
                            <h3>For Creative Enthusiasts</h3>
                            <h4>Master Visual Storytelling!</h4>
                            <p>
                                Passionate about art and design? Our courses provide comprehensive training in graphic design tools and techniques
                                to turn your creative ideas into professional visual solutions. Whether you're a beginner or looking
                                to refine your skills, join us to master the art of visual communication!
                            </p>
                        </div>
                        <div className="audience-card">
                            <span className="card-number">6</span>
                            <h3>For Social Media Content Creators</h3>
                            <h4>Create Stunning Visual Content!</h4>
                            <p>
                                Already creating content online? Transform your basic design knowledge into powerful
                                visual skills! Discover how to create eye-catching graphics, social media posts, and visual branding that
                                captures attention and builds your online presence. Unlock the full potential of visual storytelling!
                            </p>
                        </div>
                    </div>
                </section>
                <div className="about-section-wrapper">
                    <div className="about-left">
                        <div className="internship-images">
                            <img src={person2} alt="internship-home" />
                        </div>

                    </div>


                    <div className="about-right">
                        <h6 className="about-subtitle">About Us</h6>
                        <h2 className="about-title">
                            WHO WE ARE
                        </h2>
                        <div className="about-summary">

                            <div className="about-description">
                                <p>
                                    At Papa Digital Academy, we are more than just a design school - we are your creative
                                    partners in building a successful design career.
                                    Our mission is to empower aspiring designers and creative professionals by providing innovative, hands-on graphic design
                                    education that drives creativity, skill development, and career success.
                                </p>
                                <p>
                                    Founded on the principles of creativity, innovation, and student success, we pride
                                    ourselves on delivering exceptional design education through industry-standard software and expert
                                    guidance. Our academy is helmed by design professionals with more than 5+ years
                                    of experience in creative design and branding. With such vast expertise behind us, Papa
                                    Digital Academy aims to become the go-to destination for students, creative enthusiasts, and
                                    professionals looking to master graphic design skills and build successful design careers.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="internship-offer-section">
                    <div className="internship-home3">
                        <div className="internship-images">
                            <img src={internship5} alt="internship-home" />
                        </div>

                        <div className="internship-texts">
                            <h2 className="about-title">WHAT WE OFFER</h2>
                            <div className="about-description">
                                <p>
                                    At Papa Digital Academy, we do more than just teach design software—you'll receive creative mentorship, artistic guidance,
                                    and career coaching from industry professionals who've built successful design careers. Our goal is to raise
                                    the bar for creative talent by building a culture of design excellence, innovation, and professionalism.
                                    Here's how we do it:
                                </p>
                                <ul>
                                    <li>
                                        <strong>Live Projects & Portfolio Development:</strong> Our unique approach allows you to learn by creating.
                                        You'll work on real client projects, building an impressive portfolio as you master design skills.
                                    </li>
                                    <li>
                                        <strong>Creative Excellence & Professional Standards:</strong> We emphasize creative thinking and professional design standards,
                                        ensuring our students develop both the artistic vision and technical skills needed to excel in the industry.
                                    </li>
                                    <li>
                                        <strong>Expert Mentorship & Creative Guidance:</strong> You won't just attend classes—you'll be mentored by expert designers with
                                        years of industry experience, giving you personalized feedback and creative direction throughout your learning journey.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="timings-section">
                    <h2 className="about-title">TIMINGS</h2>
                    <div className="timings-top">
                        <div className="timing-box">
                            <div className="timing-icon">🎨</div>
                            <p><strong>MON–FRI, 2 hours live design classes.</strong></p>
                        </div>
                        <div className="timing-box">
                            <div className="timing-icon">🎨</div>
                            <p><strong>3 Months of Creative & Proven Design Training Method</strong></p>
                        </div>
                    </div>

                    <div className="timings-features">
                        {[
                            { icon: image1, text: 'Live design coaching' },
                            { icon: image2, text: 'Beginner Friendly' },
                            { icon: image3, text: 'Design Certification' },
                            { icon: image4, text: 'One-on-one creative sessions' },
                            { icon: image5, text: '100% portfolio assistance' },
                            { icon: image6, text: 'Top Industry Design Mentors' },
                        ].map((feature, index) => (
                            <div className="feature-item" key={index}>
                                <div className="feature-icon">
                                    <img src={feature.icon} alt={feature.text} style={{ width: 32, height: 32 }} />
                                </div>
                                <p>{feature.text}</p>
                            </div>
                        ))}
                    </div>

                </section>
                <div className="whatweoffer-container">
                    <div className="offer-image">
                        <img src={about} alt="What We Offer" />
                    </div>
                    <div className="offer-content">
                        <h2>Why Join Our Design Program?</h2>
                        <ul>
                            <li>Hands-on experience with real design projects</li>
                            <li>Mentorship from professional graphic designers</li>
                            <li>Flexible learning for students, professionals, and creative enthusiasts</li>
                            <li>Opportunities to build an impressive design portfolio</li>
                            <p>At Papa Digital Academy, we believe in the power of creative expression and the
                                importance of quality design education. Join us, and let's build a bright, successful
                                creative future together!</p>
                        </ul>
                    </div>
                </div>
                <section className="syllabus-section">
                    <h2 className="about-title">CURRICULUM</h2>
                    <div className="syllabus-columns">
                        {syllabusItems.map((column, colIndex) => (
                            <ul className="syllabus-column" key={colIndex}>
                                {column.map((item, index) => (
                                    <li key={index} className="syllabus-item">
                                        <span className="syllabus-icon">🎨</span>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        ))}
                    </div>
                </section>

                {/* <div>
                    <h3 onClick={handleDownload} className="blinking-text">
                        For More Info <span style={{ color: "#00aaff" }}>CLICK HERE</span>
                    </h3>
                </div> */}
            </div>
            <Footer />
        </div>
    )
}

export default InternshipGraphics